import { render, staticRenderFns } from "./BuscarAbonadoSGA.vue?vue&type=template&id=24c9e228"
import script from "./BuscarAbonadoSGA.vue?vue&type=script&lang=js"
export * from "./BuscarAbonadoSGA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports